import React from "react";
import styled from "styled-components";
import { colors } from "utils";
import { useImQuestionBrowserFilters } from "./useImQuestionBrowserFilters";
import { FiltersBar } from "./FiltersBar";
import { ItemsList } from "./ItemsList";

const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const Heading = styled.h2`
  color: ${colors.nightlyWoods900 || "#111827"};
  font-size: 22px;
  font-weight: 600;
  margin: 0;
`;

export const ImQuestionBrowser = () => {
  const filters = useImQuestionBrowserFilters();

  return (
    <Page>
      <Heading>IM Question Browser</Heading>
      <FiltersBar filters={filters} />
      <ItemsList
        items={filters.filteredItems}
        loading={filters.itemsLoading}
        error={filters.itemsError}
        hasLesson={!!filters.lesson}
      />
    </Page>
  );
};
